import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import { formatMoney, formatDate } from '../utils/format';
import StatusBadge from '../components/StatusBadge';
import Pagination from '../components/Pagination';
import PageHeader from '../components/PageHeader';

const STATUS_OPTIONS = ['', 'active', 'ended', 'cancelled'];

export default function Auctions() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const pageSize = 15;

  useEffect(() => {
    setLoading(true);
    api.get('/auctions', { params: { status: status || undefined, search: search || undefined, page, pageSize } })
      .then((res) => {
        setRows(res.data.data);
        setTotal(res.data.total);
      })
      .finally(() => setLoading(false));
  }, [status, search, page]);

  return (
    <div>
      <PageHeader title="Auctions" subtitle="Browse and filter every auction listing." />

      <div className="toolbar">
        <input
          className="search-input"
          placeholder="Search by title, lot or serial number…"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
        />
        <select value={status} onChange={(e) => { setStatus(e.target.value); setPage(1); }}>
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>{s ? s[0].toUpperCase() + s.slice(1) : 'All statuses'}</option>
          ))}
        </select>
      </div>

      <div className="panel">
        <table className="data-table">
          <thead>
            <tr>
              <th>Title</th><th>Lot #</th><th>Current Price</th><th>Bids</th>
              <th>Status</th><th>Ends</th><th>Winner</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan="7" className="empty-cell">Loading…</td></tr>}
            {!loading && rows.length === 0 && (
              <tr><td colSpan="7" className="empty-cell">No auctions found</td></tr>
            )}
            {!loading && rows.map((a) => (
              <tr key={a.id}>
                <td><Link to={`/auctions/${a.id}`}>{a.title}</Link></td>
                <td>{a.lot_number || '—'}</td>
                <td>{formatMoney(a.current_price ?? a.starting_price)}</td>
                <td>{a.bid_count}</td>
                <td><StatusBadge value={a.status} /></td>
                <td>{formatDate(a.end_time)}</td>
                <td>{a.winner_username || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination page={page} pageSize={pageSize} total={total} onChange={setPage} />
    </div>
  );
}
